import Util from '../../util/index.js';
import Matrix from '../matrix';
export default class Matrix2d extends Matrix{
  constructor(args) {
    super(args);
    this.matrix = args;
    this.dimension = this.calcMatrixDimension(args);
    this.matrixDet = this.calcMatrixDet();
  }
  /**
   * 计算矩阵维数
   */
  static calcMatrixDimension(matrix) {
    const column = matrix.length;
    const row = matrix[0].length;
    const isValid = matrix.every(a => Util.isArray(a) && a.length === row);
    if (!isValid) {
      throw new Error('data has different dimension');
    }
    return [column, row];
  }
  /**
   * 计算3*3矩阵的行列式
   */
  static calcMatrixDet(matrix) {
    const [column, row] = this.calcMatrixDimension(matrix);
    if (column === row && column === 3) {
      let matrixDet = 0;
      for (let i = 0; i < column; i++) {
        let value = 1, subValue = -1;
        for (let j = 0; j < row; j++) {
          const k = (j + i) % column;
          value *= matrix[k][j];
          const m = (i - j + column) % column;
          subValue *= matrix[m][j];
        }
        matrixDet += value + subValue;
      }
      if (Util.isValidNumber(matrixDet)) {
        return matrixDet;
      } else {
        throw new Error(`matrix ${matrix} has no currect Det`);
      }
    } else {
      throw new Error(`matrix ${matrix} has different dimension column: ${column} and row: ${row}`);
    }
  }
  /**
   * 计算3*3逆矩阵
   */
  static calcInverseMatrix(matrix) {
    const matrixDet = this.calcMatrixDet(matrix);
    const [column, row] = this.calcMatrixDimension(matrix);
    const targetMatrix = [];
    if (Util.isValidNumber(matrixDet) && matrixDet !== 0) {
      if (column === row && column === 3) {
        for (let i = 0; i < row; i++) {
          const columnMatrix = [];
          targetMatrix.push(columnMatrix);
          for (let j = 0; j < column; j++) {
            const k = Math.pow(-1, i + j);
            const M = [];
            // 计算代数余子式
            for (let m = 0; m < row; m++) {
              if (m !== i) {
                const N = [];
                M.push(N);
                for (let n = 0; n < column; n++) {
                  if (n !== j) {
                    N.push(matrix[n][m]);
                  }
                }
              }
            }
            const A = k * (M[0][0] * M[1][1] - M[0][1] * M[1][0]) / matrixDet;
            columnMatrix.push(A);
          }
        }
        return targetMatrix;
      }
    }
  }
  /**
   * 计算二维矩阵乘积
   */
  static transition(leftMatrix, rightMatrix) {
    try {
      if (Util.isArray(leftMatrix) && Util.isArray(rightMatrix)) {
        const [leftColumn, leftRow] = this.calcMatrixDimension(leftMatrix);
        const [rightColumn, rightRow] = this.calcMatrixDimension(rightMatrix);
        if (leftColumn === rightRow) {
          const newMatrix = []
          for (let k = 0; k < rightColumn; k++) {
            const newColumn =[];
            for (let j = 0; j < leftRow; j++) {
              let value = 0;
              for (let i = 0; i < leftColumn; i++) {
                value += leftMatrix[i][j] * rightMatrix[k][i];
              }
              newColumn.push(value);
            }
            newMatrix.push(newColumn);
          }
          return newMatrix;
        }
      }
    } catch(e) {
      throw new Error('matrix has different dimension');
    }
  }
}